import React from "react";
import { FiArrowRight } from "react-icons/fi";

const CourseContent = ({ content }) => {
    return (
        <div className="course-content rounded p-4">
            <h2 className="mb-4">Course Topics</h2>
            {content && content.length > 0 ? (
                content.map((item, index) => (
                    <div
                        key={index}
                        className="d-flex align-items-center gap-2 mb-2 ps-2 py-2"
                    >
                        <h3><FiArrowRight className="text-primary" /></h3>
                        <h4>{item.value}</h4>
                    </div>
                ))
            ) : (
                <p>No topics available.</p>
            )}
        </div>
    );
};

export default CourseContent;
